import { cn } from "@utils/cn";
import React from "react";

interface BaseTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  className?: string;
  size?: number | string;
  color?: string;
}

function ShiftIconMain({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("inline-flex items-center justify-center", className)}
      {...props}
    >
      {children}
    </div>
  );
}

const Day = ({ className, size = 28, style, color, ...props }: BaseTextProps) => {
  return (
    <span
      className={cn(
        "font-bold text-white flex items-center justify-center shrink-0",
        "bg-day",
        className
      )}
      style={{
        width: size,
        height: size,
        borderRadius: "5px",
        fontSize: "14px",
        backgroundColor: color,
        ...style,
      }}
      {...props}
    >
      D
    </span>
  );
};

const Evening = ({
  className,
  size = 28,
  style,
  color,
  ...props
}: BaseTextProps) => {
  return (
    <span
      className={cn(
        "font-bold text-white flex items-center justify-center shrink-0",
        "bg-evening",
        className
      )}
      style={{
        width: size,
        height: size,
        borderRadius: "5px",
        fontSize: "14px",
        backgroundColor: color,
        ...style,
      }}
      {...props}
    >
      E
    </span>
  );
};

const Night = ({
  className,
  size = 28,
  style,
  color,
  ...props
}: BaseTextProps) => {
  return (
    <span
      className={cn(
        "font-bold text-white flex items-center justify-center shrink-0",
        "bg-night",
        className
      )}
      style={{
        width: size,
        height: size,
        borderRadius: "5px",
        fontSize: "14px",
        backgroundColor: color,
        ...style,
      }}
      {...props}
    >
      N
    </span>
  );
};

const Mid = ({
  className,
  size = 28,
  style,
  color,
  ...props
}: BaseTextProps) => {
  return (
    <span
      className={cn(
        "font-bold text-white flex items-center justify-center shrink-0",
        className
      )}
      style={{
        width: size,
        height: size,
        borderRadius: "5px",
        fontSize: "14px",
        backgroundColor: color,
        ...style,
      }}
      {...props}
    >
      M
    </span>
  );
};

export const ShiftIcon = Object.assign(ShiftIconMain, {
  Day,
  Evening,
  Night,
  Mid,
});

export default ShiftIcon;
